import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import getNotificationText from 'swag-common/utils/product/get-notification-text-for-product-quantity.util';
import { MIN_RELATED_AMOUNT } from '../../../../customer/redux/related-product-builder-popup/product.utils';
import { QuantityForColor as QuantityForColorComponent } from './quantity-for-color';
const propsSelector = (state, props) => props;
const isVariantOutOfStockSelector = createSelector(propsSelector, ({
  variant
}) => (variant === null || variant === void 0 ? void 0 : variant.isVariantInStock) === false);
const isDisabledSelector = createSelector(propsSelector, isVariantOutOfStockSelector, ({
  disabled,
  isOrderMoreOutOfStock
}, isVariantOutOfStock) => !!(disabled || isVariantOutOfStock || isOrderMoreOutOfStock));
const errorMessageSelector = createSelector(propsSelector, isDisabledSelector, isVariantOutOfStockSelector, ({
  showError,
  stockLevelsByVariantSku,
  quantity,
  sharedQuantity,
  isShared,
  isRelated,
  variant,
  outOfStockExpireDate,
  productIsAlwaysInStock,
  quantIncrement
}, isDisabled, isVariantOutOfStock) => !isDisabled && !!showError && stockLevelsByVariantSku ? getNotificationText({
  quantityForCurrentItem: quantity,
  sharedQuantityForCurrentItem: sharedQuantity,
  isShared: !!isShared,
  minQuantity: isRelated ? MIN_RELATED_AMOUNT : 0,
  quantIncrement: isRelated ? 1 : quantIncrement,
  variants: [variant],
  stockLevelsByVariantSku,
  isVariantOutOfStock,
  outOfStockExpireDate,
  productIsAlwaysInStock: !!productIsAlwaysInStock
}) : '');
const mapStateToProps = createStructuredSelector({
  isDisabled: isDisabledSelector,
  errorMessage: errorMessageSelector
});
export const QuantityForColor = connect(mapStateToProps)(QuantityForColorComponent);